import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { isEndMarketRole } from "../../helpers/endMarket";
import InactiveStatus from "../InactiveStatus";
import { TransactionParticipant } from "../../types";

import styles from "./ParticipantInfo.module.scss";

interface Props {
  participant: TransactionParticipant;
  className?: string;
  isStaffView?: boolean;
  isCompanyActive?: boolean;
}

export const ParticipantInfo = ({
  participant,
  className,
  isStaffView,
  isCompanyActive,
}: Props) => {
  const { t } = useTranslation();
  const { businessRoleCode, companyId, regNumber, displayName } = participant;
  const isEndMarket = isEndMarketRole(businessRoleCode);

  return (
    <div className={classnames(styles.participantInfo, className)}>
      <div className={styles.roleInfo}>
        <span>{`${t(`businessRoles.${businessRoleCode}`)} · `}</span>
        {isStaffView ? (
          <>
            <Link
              className={styles.regNumber}
              to={`${
                isEndMarket ? "/end-market" : ""
              }/participants/${companyId}`}
            >
              {`#${regNumber}`}
            </Link>
            {!isCompanyActive && (
              <span className={styles.additionalDot}>
                <InactiveStatus />
              </span>
            )}
          </>
        ) : (
          <span className={styles.regNumber}>{`#${regNumber}`}</span>
        )}
      </div>
      <h4>{displayName}</h4>
    </div>
  );
};

export default ParticipantInfo;
